import { useEffect, useRef, useState } from 'react'

import { ArrowDownDate } from '@assets/svgs/ArrowDownDate'
import { ArrowLeftDate } from '@assets/svgs/ArrowLeftDate'
import { ArrowRightDate } from '@assets/svgs/ArrowRightDate'

import type { HeaderDateProps } from './types'

import * as S from './styles'

export const HeaderDate = ({
  date,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  decreaseMonth,
  increaseMonth,
  changeYear
}: HeaderDateProps) => {
  const [showYearMenu, setShowYearMenu] = useState(false)

  const minDate = new Date(1990, 0, 1)
  const maxDate = new Date(2100, 11, 31)
  const minYear = minDate.getFullYear()
  const maxYear = maxDate.getFullYear()

  const monthName = date.toLocaleString('pt-BR', { month: 'long' })
  const capitalizedMonthName = monthName.charAt(0).toUpperCase() + monthName.slice(1)

  const selectedYearRef = useRef<HTMLButtonElement | null>(null)
  const yearMenuRef = useRef<HTMLButtonElement | null>(null)

  useEffect(() => {
    if (showYearMenu && selectedYearRef.current) {
      selectedYearRef.current.scrollIntoView({ block: 'center' })
    }
  }, [showYearMenu, date])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (yearMenuRef.current && !yearMenuRef.current.contains(event.target as Node)) {
        setShowYearMenu(false)
      }
    }

    if (showYearMenu) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showYearMenu])

  return (
    <S.Container>
      <S.TextContent>
        <S.Text>
          {capitalizedMonthName} {date.getFullYear()}
        </S.Text>

        <S.YearButton
          ref={yearMenuRef}
          type="button"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setShowYearMenu((v) => !v)
          }}
        >
          <ArrowDownDate />

          {showYearMenu && (
            <S.YearBoxOpen>
              {Array.from({ length: maxYear - minYear + 1 }, (_, i) => maxYear - i).map((y) => (
                <S.YearButtonOpen
                  key={y}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    changeYear(y)
                    setShowYearMenu(false)
                  }}
                  $isSelected={y === date.getFullYear()}
                  ref={y === date.getFullYear() ? selectedYearRef : undefined}
                >
                  {y}
                </S.YearButtonOpen>
              ))}
            </S.YearBoxOpen>
          )}
        </S.YearButton>
      </S.TextContent>

      <S.MonthsButtonBox>
        <S.MonthButton type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
          <ArrowLeftDate />
        </S.MonthButton>
        <S.MonthButton type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
          <ArrowRightDate />
        </S.MonthButton>
      </S.MonthsButtonBox>
    </S.Container>
  )
}
